import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

import {DEAL_FREEZE_OFFER_BOX_CARD_SKELETON} from './constants'

export const DealFreezeOfferBoxCardSkeleton = () => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    height="100%"
    width="100%"
    data-id={DEAL_FREEZE_OFFER_BOX_CARD_SKELETON}
  >
    <div>
      <SkeletonLoader width={100} />
      <SkeletonLoader width={150} />
    </div>
    <Box marginTop="s600">
      <SkeletonLoader width={90} />
      <SkeletonLoader />
    </Box>
  </Box>
)
